var Linkr = function(cfg) {
    var serialize = function(obj) {
        var str = [];
        for (var p in obj)
            if (obj.hasOwnProperty(p)) {
                if (obj[p] instanceof Array) {
                    str.push(encodeURIComponent(p) + '=' + encodeURIComponent(JSON.stringify(obj[p])));
                } else if (obj[p] instanceof Object) {
                    str.push(encodeURIComponent(p) + '=' + encodeURIComponent(JSON.stringify(obj[p])));
                } else {
                    str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
                }
            }
        return str.join('&');
    };

    // var C_ASSETS_URL        = config.assets;
    return {
        widget: {
            iframe: function(client, user, theme, name, qs) {
                client = client || 'core';
                user = user || 'rlz';
                theme = theme || 'default';
                name = name || '$widgetName';

                return `${cfg.widgets.url}/widget/${[client, user, theme, name].join('/')}/iframe?${serialize(
                    qs || {},
                )}`;
            },
            esi: function(client, user, theme, name, qs) {
                client = client || 'core';
                user = user || 'rlz';
                theme = theme || 'default';
                name = name || '$widgeName';
                return `${cfg.widgets.url}/widget/${[client, user, theme, name].join('/')}/esi?${serialize(qs || {})}`;
            },
            sm: function(client, user, theme, name, qs) {
                client = client || 'core';
                user = user || 'rlz';
                theme = theme || 'default';
                name = name || '$widgeName';

                return `${cfg.widgets.url}/widget/${[client, user, theme, name].join('/')}/sm?${serialize(qs || {})}`;
            },
            image: function(client, user, theme, name, qs) {
                client = client || 'core';
                user = user || 'rlz';
                theme = theme || 'default';
                name = name || '$widgeName';
                return `${cfg.widgets.url}/widget/${[client, user, theme, name].join('/')}/hash-image?${serialize(
                    qs || {},
                )}`;
            },
            demo: function(client, user, theme, name, qs) {
                client = client || 'core';
                user = user || 'rlz';
                theme = theme || 'default';
                name = name || '$widgeName';
                return `${cfg.widgets.url}/widget/${[client, user, theme, name].join('/')}/demo-image?${serialize(
                    qs || {},
                )}`;
            },
            animated: function(client, user, theme, name, qs) {
                client = client || 'core';
                user = user || 'rlz';
                theme = theme || 'default';
                name = name || '$widgeName';
                return `${cfg.widgets.url}/widget/${[client, user, theme, name].join('/')}/animated?${serialize(
                    qs || {},
                )}`;
            },
            scriptPath: function(name) {
                return cfg.assets + '/js/standalone/' + name + '.js?v=' + cfg.widgets.version;
            },
        },
        injector: function() {
            return cfg.assets + '/js/core/rlz-widget-injector.js?v=' + cfg.injector.version;
        },
        serialize: serialize,
        client: {
            cssPath: function(client, user, theme) {
                client = client || 'core';
                user = user || 'rlz';
                theme = theme || 'default';
                return (
                    cfg.assets + '/css/clients/' + client + '.' + user + '.' + theme + '.css?v=' + cfg.widgets.version
                );
            },
        },
    };
};

module.exports = Linkr;



/** WEBPACK FOOTER **
 ** ../src/config/Linkr.js
 **/